<div class="avi-dropdown clr-wrapper">
    <div
        #aviDropdown
        class="{{ getContainerClassNames() }}"
        avi-tooltip
        (openedChange)="handleOpenedChange($event)"
        [showOnClick]="true"
        [positionsPriority]="optionsPositionsPriority"
        [tooltipControl$]="dropdownOptionsControl$"
        [overlaySizeChange$]="optionsLength$"
        [hideTooltip]="readonly || disabled || reachedMaxSelected() || viewMode"
        [overlayMaxWidth]="elementWidth"
        tabindex="0"
        [attr.disabled]="disabled"
    >
        <div
            #aviDropdownOpener
            class="avi-dropdown__opener sel-avi-dropdown__opener"
        >
            <div
                [hidden]="!value || !hasTranscludedSelectedValuesContainer"
                class="avi-dropdown__selected-values-container"
                #selectedValuesContainerContent
            >
                <ng-content select="[aviDropdown_selectedValuesContainer]"></ng-content>
            </div>
            <avi-dropdown-selected-values-container
                *ngIf="!hasTranscludedSelectedValuesContainer"
                [hidden]="!value"
                class="avi-dropdown__selected-values-container"
                [selectedOptions]="selectedDropdownOptions"
                [multiple]="multiple"
                [prepend]="prepend"
                (onRemoveValue)="handleRemoveValue($event)"
                [disabled]="disabled"
            ></avi-dropdown-selected-values-container>
            <div
                class="avi-dropdown__placeholder"
                [hidden]="value"
            >
                {{ viewMode ? (l10nKeys.notConfiguredPlaceholder | vtranslate) : placeholder }}
            </div>
            <cds-icon
                [hidden]="readonly || viewMode"
                class="avi-dropdown__opener-icon"
                [ngClass]="{ 'avi-dropdown__opener-icon--unclickable': reachedMaxSelected() }"
                shape="angle"
                direction="down"
                size="14"
            ></cds-icon>
        </div>
        <ng-template #aviTooltipContent>
            <avi-dropdown-menu
                [hideSearch]="hideSearch"
                searchTerm="{{ searchTerm }}"
                (onSearch)="handleSearch($event)"
                (onDestroy)="hideDropdownOptions()"
            >
                <avi-dropdown-options
                    [options]="options | isHidden: hiddenValues | isFilteredBySearch: searchTerm : customSearch"
                    [optionsLengthSubject]="optionsLengthSubject"
                    [selectedOptions]="selectedDropdownOptions"
                    (onOptionSelect)="handleSelect($event)"
                    [width]="elementWidth"
                    (onScrollEnd)="handleScrollEnd($event)"
                    [busy]="busy"
                    [optionSignpostTemplateRef]="optionSignpostTemplateRef"
                    (onEscape)="handleDropdownOptionsEscape()"
                ></avi-dropdown-options>
            </avi-dropdown-menu>
        </ng-template>
    </div>
    <button
        type="button"
        (click)="handleClearAll($event)"
        class="avi-dropdown__clear-button sel-avi-dropdown-clear-button"
        [hidden]="readonly || !value || disabled || required || viewMode"
        title="{{ l10nKeys.clearAllLabel | vtranslate }}"
    >
        <cds-icon
            class="avi-dropdown__clear-button-icon"
            shape="times-circle"
            size="18"
        ></cds-icon>
    </button>
    <div
        class="avi-dropdown__helper-text"
        [hidden]="!helperText"
    >
        {{ helperText }}
    </div>
</div>
